const prodDomains = {
  toyota: 'mytoyotamanual.eu',
  lexus: 'mylexusmanual.eu',
  subaru: 'manuals.subaru.com'
}

export const specificOriginMap = new Map([
  [prodDomains.toyota, ['toyota', `https://${prodDomains.toyota}`]],
  [prodDomains.lexus, ['lexus', `https://${prodDomains.lexus}`]],
  [prodDomains.subaru, ['subaru', `https://${prodDomains.subaru}`]],
  // ['localhost', ['lexus', 'http://localhost:3000']] // uncomment this to have only one brand

  // dev domains
  ['diva.dev.tweddle.app', ['toyota', 'https://diva.dev.tweddle.app']],
  ['diva-subaru.dev.tweddle.app', ['subaru', 'https://diva-subaru.dev.tweddle.app']]
])

export const specificOriginTitleMap = new Map([
  ['toyota', 'Information for Toyota vehicle owners'],
  ['lexus', 'Information for Lexus vehicle owners'],
  ['subaru', 'Subaru Owner’s Information Portal']
])

export const determineSpecificOrigin = origin => specificOriginMap.get(origin) || []

export const getCookieyesEnvVariableName = origin => {
  const domainMapping = specificOriginMap.get(origin)
  if (!domainMapping) return null
  const [brand] = domainMapping
  return `COOKIEYES_CLIENT_ID_${brand.toUpperCase()}`
}
